import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, fade } from "@material-ui/core";

function NtkInputField(props) {
  const useNtkInput = makeStyles((theme) => ({
    root: {
      border: "0.5px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: "#fcfcfb",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:hover": {
        backgroundColor: "#fff",
      },
      "&$focused": {
        backgroundColor: "#fff",
        boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 1px`,
        borderColor: theme.palette.secondary.main,
        border: "1px thin",
      },
      "& .MuiInputBase-input": {
        margin: "2em 1em",
      },
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        "& .MuiInputBase-input": {
          margin: "1em",
        },
      },
    },
    focused: {},
  }));
  const classes = useNtkInput();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export default NtkInputField;
